import { render } from "./Select2.vue?vue&type=template&id=9a3dc972&ts=true&lang=pug"
import script from "./Select2.vue?vue&type=script&lang=ts"
export * from "./Select2.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\AgentesAzure\\SVRAPPHIR04\\vsts-agent-win-x64-4.261.0\\_work\\6\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__